import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { AddonInterface } from "../../../../store/mine_craft/addonsSlice";
import { fetchUser } from "../../../../actions/mine_craft/usersActions";
import { selectUserById } from "../../../../store/mine_craft/usersSlice";

import { RightSidebar } from "../../../_partials/Layout";
import Meta from "../../Users/_partials/_Meta";
import {Avatar, Image} from "antd";
import {AppleOutlined} from "@ant-design/icons";

const _SidebarShow = ({ addon }: { addon: AddonInterface | undefined }) => {
  const dispatch  = useAppDispatch();
  const user      = useAppSelector(state => addon?.user_id ? selectUserById(state, addon?.user_id) : undefined);
  const images    = addon?.description_html?.match(/<img.*?src="(.*?)".*?>/g) || [];

  useEffect(() => {
    if (addon?.user_id) {
      dispatch(fetchUser(addon?.user_id));
    }
  }, [addon, dispatch]);

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      <Avatar
        src={user?.bundle_ico_url}
        alt='Bundle icon'
        size={50}
        icon={<AppleOutlined />}
        shape='square'
      />
      <h6 className="v-content-label o-sm v-mt-10">{user?.bundle?.name}</h6>

      <h6 className="v-content-label o-sm v-mt-25">User</h6>
      {<Meta user={user} />}

      <h6 className="v-content-label o-sm v-mt-25">Images</h6>
      <div className='v-addon-show__images'>
        <Image.PreviewGroup>
          {images.map((image, index) => {
            const src = image.match(/src="(.*?)"/) || [];

            return (
              <Image
                key={index}
                src={src[1]}
                alt='Addon image'
                width={100}
              />
            );
          })}
        </Image.PreviewGroup>
      </div>
    </RightSidebar>
  )
}

export default _SidebarShow;
